import { component } from 'picoapp';
import Modal from 'utils/modal';

export default component((node) => {
  // Modal
  const modalElement: HTMLElement = node.querySelector('[data-modal]');
  const sortButton: HTMLButtonElement = node.querySelector('[data-sort-button]');
  const sortCloseBtns: NodeListOf<HTMLElement> = node.querySelectorAll('[data-sort-close]');
  const modal = Modal(modalElement, modalElement);

  sortButton.addEventListener('click', () => {
    modal.toggle();
  });

  sortCloseBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      modal.close();
    });
  });

  modal.on('opened', () => {
    node.classList.add('is-open');
  });

  modal.on('closed', () => {
    node.classList.remove('is-open');
  });

  // Sort - Section Rendering API
  const items = [...node.querySelectorAll<HTMLInputElement>('[data-sort-item]')];

  items.forEach((item) => {
    item.addEventListener('change', () => {
      if (item.checked) {
        const url = new URL(window.location.href);

        url.searchParams.set('sort_by', item.value);

        const event = new CustomEvent('collection:sort:apply', {
          detail: { url },
        });

        document.dispatchEvent(event);

        setTimeout(() => {
          modal.close();
        }, 100);
      }
    });
  });
});
